import React, { useEffect, useState, ReactNode } from "react";
import { Alert, Row, Col, Form, Label, UncontrolledTooltip } from "reactstrap";

import { Navbar, Nav, Container, Offcanvas, Button } from "react-bootstrap";
import "react-phone-input-2/lib/style.css";

// router
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";

import logo from "../../assets/images/logo.webp";
import letterLogo from "../../assets/images/letter-logo.webp";
import topLogo from "../../assets/images/top-logo.webp";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../../components/LanguageSelector";

const Privacy = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const handleLogoClick = () => {
    navigate("/landing-page");
  };
  return (
    <div className="contact-us">
      <div className=" flex-grow-1">
        <Navbar expand="lg" className="px-3 pt-3">
          <Container fluid>
            {/* Left: Logo */}
            <Navbar.Brand
              onClick={handleLogoClick}
              style={{ cursor: "pointer" }}
            >
              <img
                src={topLogo}
                alt="Logo"
                width="160"
                height="40"
                className="d-inline-block align-center"
              />
            </Navbar.Brand>
            <span className="d-flex gap-3">
              <span className="d-block d-lg-none">
                <LanguageSwitcher />
              </span>
              <Navbar.Toggle
                aria-controls="offcanvasNavbar-expand"
                style={{ fontSize: "1rem", padding: "5px 7px" }}
              />
              <Navbar.Offcanvas
                id="offcanvasNavbar-expand"
                aria-labelledby="offcanvasNavbarLabel-expand"
                placement="end" // Right side
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title id="offcanvasNavbarLabel-expand">
                    {t("Menu")}
                  </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  {/* Center-Right: Menu Items */}
                  <Nav className="ms-auto me-3">
                    <Button
                      className="rounded-pill py-1 d-none d-lg-block"
                      style={{
                        backgroundColor: "#ede7e7",
                        color: "gray",
                        borderColor: "#ede7e7",
                        paddingRight: "40px",
                        paddingLeft: "40px",
                      }}
                      onClick={() =>
                        window.open(
                          "https://www.gofundme.com/f/heroinvoice-die-faire-erechnungslosung-fur-kleinunternehm",
                          "_blank",
                        )
                      }
                    >
                      {t("Donate")}
                    </Button>
                    <Nav.Link as={Link} to="/about-us" className="contact-text">
                      {t("ABOUT US")}
                    </Nav.Link>
                    <Nav.Link
                      as={Link}
                      to="/learn-more"
                      className="contact-text"
                    >
                      {t("LEARN MORE")}
                    </Nav.Link>
                  </Nav>

                  {/* Right: Button */}

                  <Button
                    className="rounded-pill py-1 d-block d-lg-none my-3 w-100"
                    style={{
                      backgroundColor: "#ede7e7",
                      color: "gray",
                      borderColor: "#ede7e7",
                      paddingRight: "40px",
                      paddingLeft: "40px",
                    }}
                  >
                    {t("Donate")}
                  </Button>
                  <Button
                    className="rounded-pill px-3 py-1 d-none d-lg-block"
                    style={{ backgroundColor: "#1e587e", borderColor: "white" }}
                    onClick={() => {
                      navigate("/auth-register");
                    }}
                  >
                    {t("Try out for free")}
                  </Button>
                  <Button
                    className="rounded-pill px-3 py-1 w-100 d-block d-lg-none"
                    style={{ backgroundColor: "#1e587e", borderColor: "white" }}
                    onClick={() => {
                      navigate("/auth-register");
                    }}
                  >
                    {t("Try out for free")}
                  </Button>
                  <span className="d-none d-lg-block">
                    <LanguageSwitcher />
                  </span>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </span>
          </Container>
        </Navbar>
        <Container className="learnmore-top px-4">
          <h1>{t("Privacy Policy")}</h1>
          <div style={{ color: "gray" }}>
            <section id="section1" className="mt-30">
              <h4 className="mb-4">1. {t("Introduction")}</h4>
              <p>
                {t(
                  "Welcome to hero-invoice.com. We take your privacy seriously and want you to understand how we collect, use, and protect your personal data. This privacy policy explains your rights and our responsibilities under the General Data Protection Regulation (GDPR).",
                )}
              </p>
            </section>

            <section id="section2" className="mt-30">
              <h4 className="mb-4">2. {t("Controller of the Website")}</h4>
              <div className="d-flex gap-2">
                <span className="fw-bold">Name:</span>
                <span>Tobias Krüger</span>
              </div>
              <div className="d-flex gap-2">
                <span className="fw-bold">{t("Address")}:</span>
                <span>
                  {" "}
                  Frankenstraße 8, 92353 Postbauer-Heng, {t("Germany")}
                </span>
              </div>
              <div className="d-flex gap-2">
                <span className="fw-bold">Email:</span>
                <span>info@hero-invoice.com</span>
              </div>
              <div className="d-flex gap-2">
                <span className="fw-bold">{t("Phone")}:</span>
                <span>+49 177 5587892</span>
              </div>
              <div className="d-flex gap-2">
                <span className="fw-bold">{t("Company Type")}:</span>
                <span>{t("Sole Proprietorship")}</span>
              </div>
              <div className="d-flex gap-2">
                <span className="fw-bold">
                  {" "}
                  {t("Country of Incorporation")}:
                </span>
                <span>{t("Germany")}</span>
              </div>
              <div className="mt-4 d-flex gap-2">
                <span className="fw-bold">
                  {" "}
                  {t("Data Protection Contact")}:
                </span>
                <span> {t("Same as above.")}</span>
              </div>
            </section>

            <section id="section3" className="mt-30">
              <h4 className="mb-4">3. {t("Hosting & Technology")}</h4>
              <p>
                {t(
                  "Our website is hosted with Amazon Web Services (AWS). We do not use a content management system (CMS). The application is built with React.js as frontend and Express.js as backend.",
                )}
              </p>

              <p>
                {t(
                  "Server log files: Currently, no access logs (such as IP addresses or user agents) are collected or stored.",
                )}
              </p>
            </section>

            <section id="section4" className="mt-30">
              <h4 className="mb-4">4. {t("Tracking & Cookies")}</h4>
              <p>
                {t(
                  "We do not currently use cookies or tracking tools (e.g., Google Analytics, Facebook Pixel, etc.). Likewise, there is no cookie banner or consent management tool in place at this time.",
                )}
              </p>
              <p>
                {t(
                  "Should this change in the future, we will update this policy and request consent accordingly.",
                )}
              </p>
            </section>

            <section id="section5" className="mt-30">
              <h4 className="mb-4">5. {t("Forms and User Data")}</h4>
              <p>
                {t(
                  "We collect and process personal data via the following forms and inputs:",
                )}
              </p>
              <p className="fw-bold">{t("Contact & Feedback Forms:")}</p>
              <ul>
                <li>Name</li>
                <li>{t("Email address")}</li>
                <li>{t("IP address")}</li>
                <li>{t("Message text")}</li>
              </ul>
              <p className="fw-bold">{t("Registration Form:")}</p>
              <ul>
                <li>Name</li>
                <li>{t("Email address")}</li>
                <li>{t("Phone number")}</li>
                <li>{t("Date of birth")}</li>
                <li>{t("Password")}</li>
                <li>{t("Payment details (for premium features)")}</li>
              </ul>
              <p className="fw-bold">{t("Processing activities:")}</p>
              <ul>
                <li>{t("All data is stored in secure databases")}</li>
                <li>
                  {t(
                    "Used for document generation (invoices, PDFs, e-invoices)",
                  )}
                </li>
                <li>{t("Sent via email to intended recipients as needed")}</li>
              </ul>
            </section>

            <section id="section6" className="mt-30">
              <h4 className="mb-4">6. {t("Third-party Services")}</h4>
              <p>
                {t(
                  "We currently use the following third-party services and tools:",
                )}
              </p>

              <ul>
                <li>{t("Stripe (payment processing)")}</li>
                <li>{t("SendGrid (email delivery)")}</li>
                <li>{t("GitHub (development infrastructure)")}</li>
                <li>{t("Firebase (real-time database and hosting tools)")}</li>
                <li>{t("AWS (main infrastructure & storage)")}</li>
              </ul>
              <p className="fw-bold">{t("International Data Transfers")}</p>
              <p>
                {t(
                  "The above service providers are based in or operate from third countries (including the United States). We ensure GDPR compliance through mechanisms such as Data Processing Agreements (DPAs) and Standard Contractual Clauses (SCCs) where applicable.",
                )}
                "
              </p>
            </section>

            <section id="section7" className="mt-30">
              <h4 className="mb-4">7. {t("User Accounts")}</h4>
              <p>{t("Users can register and manage personal accounts.")}</p>
              <p>{t("The following data is stored upon registration:")}</p>
              <ul>
                <li>Name</li>
                <li>Email</li>
                <li>{t("Phone number")}</li>
                <li>{t("Date of birth")}</li>
                <li>{t("Encrypted password")}</li>
                <li>{t("Payment information (if applicable)")}</li>
              </ul>
              <p className="fw-bold">{t("Account Retention:")}</p>
              <p>
                {t(
                  "User accounts are not automatically deleted. You can request account deletion at any time by emailing: info@hero-invoice.com.",
                )}
              </p>
            </section>

            <section id="section8" className="mt-30">
              <h4 className="mb-4">8. App & Backend</h4>
              <p>
                {t(
                  "Hero-Invoice is operated via a custom React-based web app, connected to an Express.js backend. This system handles user authentication, document creation, secure storage, and transactional email delivery.",
                )}
              </p>
            </section>

            <section id="section9" className="mt-30">
              <h4 className="mb-4">9. {t("Social Media & Integrations")}</h4>
              <p>{t("Our website links to external platforms:")}</p>
              <ul>
                <li>Facebook</li>
                <li>LinkedIn</li>
                <li>GitHub</li>
                <li>GoFundMe</li>
              </ul>
              <p>
                {t(
                  "No embedded tracking or social plugins are currently in use.",
                )}
              </p>
            </section>

            <section id="section10" className="mt-30">
              <h4 className="mb-4">10. {t("Newsletter & Communication")}</h4>
              <p>
                {t(
                  "We do not currently offer a newsletter. If a newsletter feature is implemented in the future, this policy will be updated accordingly.",
                )}
              </p>
            </section>

            <section id="section11" className="mt-30">
              <h4 className="mb-4">11. {t("Future Features")}</h4>
              <p>{t("We plan to add new features, such as:")}</p>
              <ul>
                <li>{t("Embedded videos")}</li>
                <li>{t("Interactive blog elements")}</li>
                <li>{t("Automated integrations with other services")}</li>
              </ul>
              <p>
                {t(
                  "If any of these features involve the processing of personal data, this privacy policy will be updated to reflect that.",
                )}
              </p>
            </section>

            <section id="section12" className="mt-30">
              <h4 className="mb-4">12. {t("Your Rights under GDPR")}</h4>
              <p>{t("You have the right to:")}</p>
              <ul>
                <li>{t("Access your stored data")}</li>
                <li>{t("Correct inaccurate data")}</li>
                <li>{t("Request deletion")}</li>
                <li>{t("Restrict or object to data processing")}</li>
                <li>{t("Data portability")}</li>
                <li>{t("File a complaint with a supervisory authority")}</li>
              </ul>
              <p>
                {t(
                  "To exercise these rights, contact us at: info@hero-invoice.com",
                )}
              </p>
            </section>
            <section id="section13" className="mt-30">
              <h4 className="mb-4">
                13. {t("Changes to This Privacy Policy")}
              </h4>
              <p>
                {t(
                  "We may update this privacy policy at any time to reflect legal, technical, or business-related changes. Please check this page regularly to stay informed.",
                )}
              </p>

              <p>{t("Last updated: April 2025")}</p>
            </section>
          </div>
        </Container>
      </div>

      <div className="footer mt-4">
        <div className="footer-divider"></div>
        <Navbar expand="lg" className="px-3 pt-3">
          {/* Left: Logo */}
          <Navbar.Brand onClick={handleLogoClick} style={{ cursor: "pointer" }}>
            <img
              src={topLogo}
              alt="Logo"
              width="160"
              height="40"
              className="d-inline-block align-center"
            />
          </Navbar.Brand>

          {/* Center-Right: Menu Items */}
          <Nav className="ms-auto me-3">
            <Nav.Link as={Link} to="/imprint" className="text-gray">
              {t("Imprint")}
            </Nav.Link>
            <Nav.Link className="d-none d-lg-block">|</Nav.Link>
            <Nav.Link as={Link} to="/terms" className="text-gray">
              {t("Terms of Use")}
            </Nav.Link>
            <Nav.Link className="d-none d-lg-block">|</Nav.Link>
            <Nav.Link as={Link} to="/privacy" className="text-gray">
              {t("Privacy Policy")}
            </Nav.Link>
            <Nav.Link className="d-none d-lg-block">|</Nav.Link>
            <Nav.Link as={Link} to="/contact-us" className="text-gray">
              {t("Contact")}
            </Nav.Link>
          </Nav>
        </Navbar>
      </div>
    </div>
  );
};

export default Privacy;
